(function ($) {

     $(".slider-related").slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          autoplay: false,
          arrows: true,
          nextArrow: $('.slider-related-wrap .slide-next'),
          prevArrow: $('.slider-related-wrap .slide-prev'),
          responsive: [{
              breakpoint: 580,
              settings: {
                slidesToShow: 2,
                adaptiveHeight: true,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                adaptiveHeight: true,
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4
              }
            },
          ],
        });
    
    $(".slideshow-wrap .slideshow").slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          autoplay: false,
          arrows: true,
          adaptiveHeight:true,
          centerMode:true,
          centerPadding:'300px',
          nextArrow: $('.slideshow-wrap .arrows .arrow-right'),
          prevArrow: $('.slideshow-wrap .arrows .arrow-left'),
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        if (currentSlide !== nextSlide) {
            $('.slick-center + .slick-cloned').each(function(index, node) {
                var $node = $(node);
                
                setTimeout(function() {
                    $node.addClass('slick-current');
                    $node.addClass('slick-center');
                });
            });
        }
    });

    var $carousel = $('.masterhead-carousel-slider').slick({
        dots:false,
        draggable:true,
        arrows:true,
        adaptiveHeight:true,
        centerMode:true,
        centerPadding:'23%',

        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><img class="img-svg" src="/wp-content/themes/rdv/assets/images/icons/arrow-r.svg" /></button>',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img class="img-svg" src="/wp-content/themes/rdv/assets/images/icons/arrow-l.svg" /></button>',
        responsive: [
            {
              breakpoint: 1440,
              settings: {
                centerPadding:'20vw',
              }
            },
            {
              breakpoint: 770,
              settings: {
                centerPadding:'0',
                arrows:false,
                dots:true,
              }
            },
        ],
    });

    $carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var 
            direction,
            slideCountZeroBased = slick.slideCount - 1;

        if (nextSlide == currentSlide) {
            direction = "same";

        } else if (Math.abs(nextSlide - currentSlide) == 1) {
            direction = (nextSlide - currentSlide > 0) ? "right" : "left";

        } else {
            direction = (nextSlide - currentSlide > 0) ? "left" : "right";
        }

        // Add a temp CSS class for the slide animation (.slick-current-clone-animate)
        if (direction == 'right') {
            $('.slick-cloned[data-slick-index="' + (nextSlide + slideCountZeroBased + 1) + '"]', $carousel).addClass('slick-current-clone-animate');
        }

        if (direction == 'left') {
            $('.slick-cloned[data-slick-index="' + (nextSlide - slideCountZeroBased - 1) + '"]', $carousel).addClass('slick-current-clone-animate');
        }
    });

    $carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');

    });


    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
      if (scroll >= 130) {
          $(".navbar-main").addClass("navbar-fixed");
      } else {
          $(".navbar-main").removeClass("navbar-fixed");
      }
  	});

    
	 $(".primary-navigation .menu-item-has-children").each(function() {
      sub_child = $(this).find('.dropdown-menu').children().length;
      if (sub_child > 0) {
        $(this).find('> a').append('<span class="expand ml-2"><i class="icon icon-angle-down "></i></span>');
      }
    });


    $('.primary-navigation li .expand').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).find('i').toggleClass('icon-angle-down');
        $(this).find('i').toggleClass('icon-angle-up');
        $(this).parent('a').parent('li').children('.dropdown-menu').slideToggle(100);
        return false;
    })

    $('.moreless-button').click(function() {
      $(this).parent('blockquote').find('.moretext').slideToggle();
      $(this).parent('p').parent('blockquote').find('.moretext').slideToggle();
      
      var btn_text = $(this).text();
      if (btn_text.toLowerCase() === "read more") {
        $(this).text("Read less");
      } else {
        $(this).text("Read more");
      }

    });
    setTimeout(function(){ 
      $('.img-svg').each(function() {
          var $img = $(this);
          var imgURL = $img.attr('src');

          $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');
            // Replace image with new SVG
            $img.replaceWith($svg);
          });
        });
     }, 300);

    $(window).on('load', function(){

      $('body').css('pointer-events','inherit');

    });

    

     $( window ).resize(function() {
      var bld_hght = $('.bg-building').outerHeight();
      var w_hght = $(window).outerHeight();
      $('.bg-building').css('margin-top',w_hght-bld_hght);
      $('.bg-building').css('opacity','1');
    });

     $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
    });

})(jQuery);




const scroller = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true
})

gsap.registerPlugin(ScrollTrigger)


scroller.on('scroll', ScrollTrigger.update);

ScrollTrigger.scrollerProxy(
    '#page-wrap', {
        scrollTop(value) {
            return arguments.length ?
                scroller.scrollTo(value, 0, 0) :
                scroller.scroll.instance.scroll.y
        },
        getBoundingClientRect() {
            return {
                left: 0, top: 0,
                width: window.innerWidth,
                height: window.innerHeight
            }
        }
    }
);

console.log(ScrollTrigger.scrollerProxy());

ScrollTrigger.addEventListener('refresh', () => scroller.update());

ScrollTrigger.refresh();

scroller.on('scroll', (position) => {

  if ($('#home-masterhead').length) {
    var nxt_sec =  $('.slideshow-wrap').offset();
    var w_hght2 = ($(window).outerHeight()/2);
    if ((nxt_sec.top-(w_hght2*1.8))<=0) {
      $('#home-masterhead').addClass('scrolled');
      $('.navbar-main').addClass('navbar-fixed');
    } else {
      $('#home-masterhead').removeClass('scrolled');
      $('.navbar-main').removeClass('navbar-fixed');
    }
  }

});

$(document).ready(function() {
  setTimeout(function(){ 

  $('.js-scroll-to a[href*="#"]:not([href="#"])').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          var counter_limit = (target.offset().top - 20);
          var target_ID = '#'+target.attr('id');
          if (target.length) {
            scroller.scrollTo(target_ID);

            return false;
          }
      }
   });

    var bld_hght = $('.bg-building').outerHeight();
    var w_hght = $(window).outerHeight();
    $('.bg-building').css('margin-top',w_hght-bld_hght);
    $('.bg-building').css('opacity','1');

   }, 300);

  $(window).scroll(function (event) {
    var wscroll = $(window).scrollTop();
     if (wscroll >= 200) {
        $('.navbar-main').addClass('navbar-fixed');
      } else {
        $('.navbar-main').removeClass('navbar-fixed');
      }
    });
});